import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import i18n from 'i18n';
import React from 'react';
import { history } from 'store';
import Alert from '@material-ui/lab/Alert';
import Button from 'components/Button';
import clsx from 'clsx';
import { RolesEnum, CompanyData } from 'modules/authenticate/interfaces';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import styles from './styles';

interface Props {
  role?: RolesEnum;
  companySelected: CompanyData | null;
}

const NotFound: React.FC<Props> = ({ role, companySelected }) => {
  const classes = makeStyles(styles)();

  return (
    <>
      <Grid container alignItems="center" justify="center">
        <Alert className={classes.alert} severity="error" color="info">
          <span>{i18n.t('DO_NOT_HAVE_PERMISSIONS_KEY')}</span>
        </Alert>
      </Grid>
      <Grid container alignItems="center" justify="center">
        <Button
          onClick={() => history.goBack()}
          className={clsx(classes.button, {
            [classes.buttonGreen]: inAdminView(role, companySelected),
            [classes.buttonGray]: inSuperAdminView(role, companySelected),
            [classes.buttonBlue]: inOperatorView(role, companySelected),
            [classes.buttonYellow]: companySelected,
          })}
        >
          {i18n.t('BACK_KEY')}
        </Button>
      </Grid>
    </>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(NotFound);
